module.exports = __webpack_public_path__ + "2dfc1ca593c3501f06ed51b3fc446edb.png";